import { render, staticRenderFns } from "./TheOthers.vue?vue&type=template&id=93ce673e&scoped=true&"
import script from "./TheOthers.vue?vue&type=script&lang=js&"
export * from "./TheOthers.vue?vue&type=script&lang=js&"
import style0 from "./TheOthers.vue?vue&type=style&index=0&id=93ce673e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ce673e",
  null
  
)

export default component.exports